export const FooterMenu = [
  {
    items: [
      {
        label: 'Notizie',
        url: 'https://it.benzinga.com/news/',
      },
      {
        label: 'Notizie internazionali',
        url: 'https://it.benzinga.com/news/global/',
      },
      {
        label: 'Notizie USA',
        url: 'https://it.benzinga.com/news/usa/',
      },
      {
        label: 'Trading',
        url: 'https://it.benzinga.com/news/usa/trading/',
      },
      {
        label: 'Criptovalute',
        url: 'https://it.benzinga.com/crypto/',
      },
    ],
    label: 'Notizie',
  },
  {
    items: [
      {
        label: 'Licenze e sindacati',
        url: 'https://it.benzinga.com/chi-siamo-la-storia-di-bezinga/',
      },
      {
        label: 'Contenuto sponsorizzato',
        url: 'https://it.benzinga.com/chi-siamo-la-storia-di-bezinga/',
      },
      {
        label: 'Pubblicare un annuncio',
        url: 'https://it.benzinga.com/chi-siamo-la-storia-di-bezinga/',
      },
      {
        label: 'Richiesta di un Media Kit',
        url: 'https://it.benzinga.com/chi-siamo-la-storia-di-bezinga/',
      },
      {
        label: 'Chi Siamo',
        url: 'https://it.benzinga.com/chi-siamo-la-storia-di-bezinga/',
      },
    ],
    label: 'PARTNER/COLLABORATORE',
  },
  {
    items: [
      {
        label: 'Benzinga USA',
        url: 'https://www.benzinga.com/',
      },
      {
        label: 'Benzinga Corea',
        url: 'https://kr.benzinga.com/',
      },
      {
        label: 'Benzinga Giappone',
        url: 'https://jp.benzinga.com/',
      },
      {
        label: 'Benzinga Italia',
        url: 'https://it.benzinga.com/',
      },
      {
        label: 'Benzinga Spagna',
        url: 'https://es.benzinga.com/',
      },
      {
        label: 'Benzinga India',
        url: 'https://es.benzinga.com/',
      },
    ],
    label: 'BENZINGA NEL MONDO',
  },
];

export const FooterCopyRightLinks = [
  {
    label: 'Informativa Sulla Privacy',
    url: 'https://it.benzinga.com/informativa-sulla-privacy/',
  },
  {
    label: 'Termini e Condizioni',
    url: '#',
  },
  {
    label: 'Accessibility',
    url: '#',
  },
];
